/* ===== BEST IN BEADS â THEME JS ===== */

/* ââ TOAST ââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ */
let toastTimeout;
function showToast(msg) {
  const toast = document.getElementById('toast');
  if (!toast) return;
  document.getElementById('toastMsg').textContent = msg;
  toast.classList.add('show');
  clearTimeout(toastTimeout);
  toastTimeout = setTimeout(() => toast.classList.remove('show'), 2800);
}

/* ââ MONEY FORMAT âââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ */
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/* ââ CART DRAWER ââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ */
const CartDrawer = {
  drawer: null, overlay: null, cartItems: null, cartCount: null,
  cartTotal: null, cartFooter: null, cartEmpty: null,

  init() {
    this.drawer    = document.getElementById('cartDrawer');
    this.overlay   = document.getElementById('cartOverlay');
    this.cartItems = document.getElementById('cartItems');
    this.cartCount = document.getElementById('cartCount');
    this.cartTotal = document.getElementById('cartTotal');
    this.cartFooter = document.getElementById('cartFooter');
    this.cartEmpty  = document.getElementById('cartEmpty');
    if (!this.drawer) return;
    document.getElementById('cartToggle')?.addEventListener('click', () => this.open());
    document.getElementById('cartClose')?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-add-to-cart]');
      if (btn) { e.preventDefault(); this.addItem(btn.dataset.variantId, parseInt(btn.dataset.quantity || 1), btn.dataset.productTitle); }
    });
    this.refreshCount();
  },

  open() { this.drawer.classList.add('open'); this.overlay.classList.add('open'); document.body.style.overflow = 'hidden'; this.fetchAndRender(); },
  close() { this.drawer.classList.remove('open'); this.overlay.classList.remove('open'); document.body.style.overflow = ''; },

  async addItem(variantId, quantity, title) {
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(variantId), quantity }) });
      if (!res.ok) { const err = await res.json(); showToast(err.description || 'Could not add to cart'); return; }
      await this.fetchAndRender(); this.open();
      if (title) showToast(`"${title.split(',')[0]}" added to cart!`);
    } catch (err) { console.error('Add to cart failed:', err); }
  },

  async updateItem(key, quantity) {
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    await this.fetchAndRender();
  },

  async fetchAndRender() { const res = await fetch('/cart.js'); const cart = await res.json(); this.render(cart); },
  async refreshCount() { const res = await fetch('/cart.js'); const cart = await res.json(); this.updateCount(cart.item_count); },

  updateCount(count) {
    if (!this.cartCount) return;
    this.cartCount.textContent = count;
    this.cartCount.classList.toggle('hidden', count === 0);
  },

  render(cart) {
    this.updateCount(cart.item_count);
    if (!this.cartItems) return;
    if (cart.item_count === 0) {
      this.cartEmpty.style.display = 'flex'; this.cartFooter.style.display = 'none';
      this.cartItems.innerHTML = ''; this.cartItems.appendChild(this.cartEmpty); return;
    }
    this.cartEmpty.style.display = 'none'; this.cartFooter.style.display = 'block';
    this.cartTotal.textContent = formatMoney(cart.total_price);
    this.cartItems.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <div class="cart-item-gem">${item.image ? `<img src="${item.image}" alt="${this.esc(item.product_title)}" loading="lazy">` : 'ð'}</div>
        <div class="cart-item-info">
          <h4>${this.esc(item.product_title)}</h4>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item-variant">${this.esc(item.variant_title)}</p>` : ''}
          <div class="cart-item-price">${formatMoney(item.price)}</div>
          <div class="cart-item-qty">
            <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}">â</button>
            <span class="qty-val">${item.quantity}</span>
            <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
            <button class="remove-item" data-key="${item.key}" data-qty="0">Remove</button>
          </div>
        </div>
      </div>`).join('');
    this.cartItems.querySelectorAll('[data-key]').forEach(btn => {
      btn.addEventListener('click', () => this.updateItem(btn.dataset.key, parseInt(btn.dataset.qty)));
    });
  },

  esc(str) { const d = document.createElement('div'); d.textContent = str || ''; return d.innerHTML; }
};

/* ââ PRODUCT PAGE âââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ */
const ProductPage = {
  init() {
    const variantSelect = document.getElementById('variantSelect');
    if (variantSelect) variantSelect.addEventListener('change', () => this.onVariantChange(variantSelect));
    document.getElementById('qtyMinus')?.addEventListener('click', () => { const i = document.getElementById('qtyInput'); if (i && parseInt(i.value) > 1) i.value = parseInt(i.value) - 1; });
    document.getElementById('qtyPlus')?.addEventListener('click', () => { const i = document.getElementById('qtyInput'); if (i) i.value = parseInt(i.value) + 1; });
    document.querySelectorAll('.product-thumb').forEach(t => t.addEventListener('click', () => this.switchImage(t)));
  },
  onVariantChange(select) {
    const o = select.options[select.selectedIndex];
    const priceEl = document.getElementById('productPrice'), compareEl = document.getElementById('productCompare'), addBtn = document.getElementById('addToCartBtn');
    if (priceEl && o.dataset.price) priceEl.textContent = formatMoney(parseInt(o.dataset.price));
    if (compareEl && o.dataset.compare) { compareEl.textContent = formatMoney(parseInt(o.dataset.compare)); compareEl.style.display = o.dataset.compare && o.dataset.compare !== o.dataset.price ? '' : 'none'; }
    if (addBtn) { addBtn.disabled = o.dataset.available !== 'true'; addBtn.textContent = o.dataset.available === 'true' ? 'Add to Cart' : 'Sold Out'; }
  },
  switchImage(thumb) {
    const mainImg = document.getElementById('mainProductImg');
    if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
    document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  }
};

/* ââ COLLECTION SORT ââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ */
function initCollectionSort() {
  const s = document.getElementById('sortSelect'); if (!s) return;
  s.addEventListener('change', () => { const u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); window.location.href = u.toString(); });
  const cur = new URLSearchParams(window.location.search).get('sort_by'); if (cur) s.value = cur;
}

/* ââ CART PAGE ââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ */
function initCartPage() {
  document.querySelectorAll('.cart-page-qty [data-key]').forEach(btn => {
    btn.addEventListener('click', async () => {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: btn.dataset.key, quantity: parseInt(btn.dataset.qty) }) });
      window.location.reload();
    });
  });
}

/* ââ INIT âââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ */
document.addEventListener('DOMContentLoaded', () => { CartDrawer.init(); ProductPage.init(); initCollectionSort(); initCartPage(); });

/* === COWORK FIX: cart drawer === HTML uses classes; JS expects IDs. Backfill IDs then init. */
document.addEventListener('DOMContentLoaded', function() {
  var bf = function(sel, id) { var el = document.querySelector(sel); if (el && !el.id) el.id = id; };
    bf('.cart-drawer','cartDrawer');
      bf('.cart-overlay','cartOverlay');
        bf('.cart-items','cartItems');
          bf('.cart-count','cartCount');
            bf('.cart-total','cartTotal');
              bf('.cart-footer','cartFooter');
                bf('.cart-empty','cartEmpty');
                  bf('[aria-label="Cart"]','cartToggle');
                    bf('.cart-close','cartClose');
                      if (typeof CartDrawer !== 'undefined' && CartDrawer.init) CartDrawer.init();
                      });
                      